import type { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '@mui/material/Checkbox';
import * as IssuesV2Store from '../../../../../redux/issuesV2';
import Flex from '../../../../generic/Flex';
import type { Issue } from '../../../../../../shared/issuesV2';

type BaseIssueItemProps = {
  id: number;
  issue: Issue;
};

/**
 * Represents the common/base layout for the IssueItem.
 * All of the different issue categories make use of this
 * common base issue item.
 */
const BaseIssueItem : FunctionComponent<BaseIssueItemProps> = ({
  id,
  issue,
  children,
}) => {
  const dispatch = useDispatch();
  const isSelected = useSelector(IssuesV2Store.selectors.getIsIssueSelected(issue));
  const onTitleClick = () => dispatch(IssuesV2Store.actions.fetchIssueDetailsForDrawer(issue.id));

  return (
    <button type="button" className="issue-item clickable" onClick={onTitleClick}>
      <div className="issue-item__container">
        <Flex align="flex-start">
          <Checkbox
            checked={isSelected}
            onClick={(e) => e.stopPropagation()}
            onChange={() =>
              isSelected
                ? dispatch(IssuesV2Store.actions.deselectIssue(id))
                : dispatch(IssuesV2Store.actions.selectIssue(id))}
          />
        </Flex>
        {children}
      </div>
    </button>
  );
};

export default BaseIssueItem;
